module.exports = __webpack_public_path__ + "static/hello-i-m-nik-281498-unsplash-503c504cef825d42da4614244603ab56.jpg";